// extracted by mini-css-extract-plugin
export default {"cls1":"tto31WAWGdo60oDQw05f","cls2":"MHArkzN0yMU1Un3pfBBo tto31WAWGdo60oDQw05f"};